//models
import { ErrorType } from "../../../../models/HttpError";

// stores
import * as ContractStageTypeStore from '../../../../redux/middleware/ContractStageType.Middleware';

//State
import { AppState } from "../../../../redux/reducers";
import { ContractStageType } from '../../../../models/Entities/Contracts/ContractStageType';



interface IProps {
    onSelectedType: (stage: ContractStageType[]) => void;
    ContractStageTypeSelected: number[] | undefined;
    MultiselectEnable: boolean;
    noteText?: string;
}

interface ConnectedProps {
    isLoading: boolean;
    isLoadingSuccessfully: boolean;
    failOnLoading: boolean;
    error: ErrorType | undefined;
    Types: ContractStageType[] | undefined;
}

interface DispatchProps {
    GetAllContractsStageTypes: typeof ContractStageTypeStore.actionCreators.GetAllContractsStageTypes;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.ContractStageType?.isLoadingAll,
  isLoadingSuccessfully: state.ContractStageType?.successLoadingAll,
  failOnLoading: state.ContractStageType?.failOnLoadingAll,
  error: state.ContractStageType?.error,
  Types: state.ContractStageType?.list ?? []
});

export const mapDispatchToProps = {
    ...ContractStageTypeStore.actionCreators 
};
